import React, { useEffect, useReducer, useState } from 'react';
import { useLocation, Link } from 'react-router-dom';

import Select from 'react-select';
import axios from 'axios';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

import '../App.scss';

import Place from '../components/Place';
import Status from '../components/Status';
import Ticket from '../components/Ticket';
import LocalStorageService from '../utils/LocalStorageService';

import { ReactComponent as CheckinIcon } from '../assets/checkin.svg';
import { ReactComponent as CheckoutIcon } from '../assets/checkout.svg';
import { ReactComponent as NotFoundIcon } from '../assets/404.svg';
import { ReactComponent as LoadIcon } from '../assets/load.svg';

const Appdb = LocalStorageService.getService();
const AppSwal = withReactContent(Swal);

///const AppApi = 'http://10.77.78.105:9000/dev/v1';
const AppApi = 'https://snrutrack.snru.ac.th/dev/v1';

const fetchPlace = (id) => axios.get(`${AppApi}/place/${id}/`);
const fetchUser = (token) => axios.get(`${AppApi}/me/`, { headers: { Authorization: 'Bearer ' + token }, });
const fetchCheckin = (data) => axios.post(`${AppApi}/checkin/`, data);
const fetchCheckout = (data) => axios.post(`${AppApi}/checkout/`, data);
const fetchBarcode = (data, token) => axios.post(`${AppApi}/barcode/`, data, { headers: { Authorization: 'Bearer ' + token }, });
const fetchLogon = (data) => axios.post(`${AppApi}/login/`, data);
const fetchGuest = (data) => axios.post(`${AppApi}/other/`, data);

// A custom hook that builds on useLocation to parse
function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const initialState = {
    isFetching: false,
    isError: false,
    isLogin: false,
    isGuest: false,
    isAdmin: Appdb.getState('ISADMIN'),
    place: {},
    user: {},
    userid: {},
    checkin: Appdb.getData('CHECKIN'),
};

const reducer = (state, { type, payload }) => {
    switch (type) {
        case 'FETCH_PLACE_PENDING':
            return {
                ...state,
                isFetching: true,
            };
        case 'FETCH_PLACE_SCAN':
            return {
                ...state,
                isError: true,
            };
        case 'FETCH_PLACE_SUCCESS':
            return {
                ...state,
                isFetching: false,
                place: payload,
            };
        case 'FETCH_CHECKIN_SUCCESS':
            return {
                ...state,
                isFetching: false,
                checkin: payload,
            };
        case 'FETCH_USERID_SUCCESS':
            return {
                ...state,
                isFetching: false,
                userid: payload,
            };
        case 'FETCH_USER_SUCCESS':
            return {
                ...state,
                isFetching: false,
                user: payload,
            };
        case 'FETCH_GUST_SUCCESS':
            return {
                ...state,
                isFetching: false,
                isGuest: true,
                user: payload,
            };
        case 'FETCH_LOGOUT_SUCCESS':
            return {
                ...state,
                isAdmin: false,
                user: []
            };
        case 'FETCH_CHECKOUT_SUCCESS':
            return {
                ...state,
                isFetching: false,
                checkin: [],
            };
        case 'FETCH_ADMIN':
            return {
                ...state,
                isAdmin: payload,
                checkin: [],
            };
        default:
            return state;
    }
};

function App() {

    const [{ place, user, checkin, isFetching, isError, isAdmin, userid }, dispatch] = useReducer(
        reducer,
        initialState
    );

    const usequery = useQuery();
    const pId = usequery.get('placeID');
    const tId = usequery.get('Temp');

    const style = 'shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline';

    const options = [
        { value: 34.5, label: '34.5' },
        { value: 35.0, label: '35.0' },
        { value: 35.5, label: '35.5' },
        { value: 36.0, label: '36.0' },
        { value: 36.5, label: '36.5' },
    ];

    const [temp, setTemp] = useState(35.5);
    const [userID, setuserID] = useState('');
    const [lastID, setlastID] = useState('');

    //init
    useEffect(() => {
        dispatch({
            type: 'FETCH_PLACE_PENDING',
        });
        if (pId === null) {
            dispatch({
                type: 'FETCH_PLACE_SCAN',
            });
        } else {
            fetchPlace(pId)
                .then((response) => {
                    if (response.status === 200) {
                        dispatch({
                            type: 'FETCH_PLACE_SUCCESS',
                            payload: response.data,
                        });
                        onloadUser();
                    }
                })
                .catch((error) => {
                    console.log(error);
                    dispatch({
                        type: 'FETCH_PLACE_SCAN',
                    });
                });

            if (tId !== null) {
                setTemp(tId);
            }
        }
    }, [pId, tId]);

    async function onMessage(icon, msg) {
        await AppSwal.fire({
            icon: icon,
            title: <p>{msg}</p>,
            footer: 'SNRU TRACKING V3.0 @MIS',
        });
    }

    //CHECKIN
    async function setCheckin() {
        if (checkin.profile) {
            return;
        }

        if (!user.profile) {
            setLogin();
            return;
        }

        const sender = {
            citizenID: user.profile.citizen_id,
            studentID: user.profile.student_id,
            placeID: place.place_code,
            userTemp: temp,
        };

        fetchCheckin(sender).then((response) => {
            if (response.status === 200) {
                Appdb.setData('ISCHECKIN', true);
                Appdb.setData('CHECKIN', JSON.stringify(response.data));
                dispatch({
                    type: 'FETCH_CHECKIN_SUCCESS',
                    payload: response.data,
                });
                onMessage('success', 'เช็คอินสำเร็จ');
            } else {
                onMessage('error', `ดำเนินการผิดผลาดโปรดลองใหม่อีกครั้ง`);
            }
        });
    }

    //CHECKIN CODE
    async function setUserCheckin() {

        if (!userID || !place) {
            return;
        }

        const sender = {
            userID: userID,
            placeID: place.place_code,
            userTemp: temp,
        };

        const token = Appdb.getAccessToken();

        fetchBarcode(sender, token).then((response) => {
            if (response.status === 200) {
                dispatch({
                    type: 'FETCH_USERID_SUCCESS',
                    payload: response.data,
                });
                setuserID('');

            } else {
                dispatch({
                    type: 'FETCH_USERID_SUCCESS',
                    payload: { status: { error: true, message: "ไม่พบผู้ใช้งานนี้โปรดตรวจสอบรหัสผู้ใช้" } },
                });
            }
        }).catch(error => {
            dispatch({
                type: 'FETCH_USERID_SUCCESS',
                payload: { status: { error: true, message: "ไม่พบผู้ใช้งานนี้โปรดตรวจสอบรหัสผู้ใช้" } },
            });
        });

        //15 SEC
        // setTimeout(() => {
        //     dispatch({
        //         type: 'FETCH_USERID_SUCCESS',
        //         payload:[],
        //     });
        //     setuserID('');
        // }, 15000);
    }

    //CHECKOUT
    async function setCheckout() {
        if (!checkin.profile) {
            return;
        }
        const sender = {
            caseID: checkin.profile.checkin_id,
        };

        fetchCheckout(sender).then((response) => {
            if (response.status === 200) {
                dispatch({
                    type: 'FETCH_CHECKOUT_SUCCESS',
                });
                onMessage('success', 'เช็คเอ้าสำเร็จ');
            } else {
                onMessage('error', `ดำเนินการผิดผลาดโปรดลองใหม่อีกครั้ง`);
            }
        });

        Appdb.clearState('ISCHECKIN');
        Appdb.clearData('CHECKIN');
    }

    //LOGIN USER
    async function setLogin() {
        await AppSwal.fire({
            title: <p>เข้าสู่ระบบ</p>,
            html: `<input type="text" id="username" class="${style}" placeholder="ผู้ใช้"></input><input type="password" id="password" class="${style}" placeholder="รหัสผ่าน"></input>`,
            confirmButtonText: 'เข้าสู่ระบบ',
            footer: 'SNRU TRACKING',
            preConfirm: () => {
                let username = Swal.getPopup().querySelector('#username').value;
                let password = Swal.getPopup().querySelector('#password').value;
                if (username === '' || password === '') {
                    Swal.showValidationMessage(`กรุณาป้อนชื่อผู้ใช้เเละรหัสผ่าน`);
                    return;
                }
                const sender = {
                    username: username,
                    password: password,
                };

                return fetchLogon(sender)
                    .then((response) => {
                        if (response.status === 200) {
                            return { data: response.data };
                        }
                        Swal.showValidationMessage(`ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง`);
                    })
                    .catch(() => {
                        Swal.showValidationMessage(`ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง`);
                    });
            },
        }).then((result) => {
            if (result.isConfirmed === true && result.value.data) {
                Appdb.setToken(result.value.data);
                onloadUser();
            }
        });
    }

    //LOGIN GUST
    async function setGust() {
        await AppSwal.fire({
            title: <p>เข้าสู่ระบบ</p>,
            html: `<input type="text" id="username" class="${style} my-1" placeholder="รหัสประจำตัวประชาชน">`,
            confirmButtonText: 'เข้าสู่ระบบ',
            footer: 'SNRU TRACKING',
            preConfirm: () => {
                let username = Swal.getPopup().querySelector('#username').value;
                if (username === '') {
                    Swal.showValidationMessage(`กรุณาป้อนรหัสประจำตัวประชาชน`);
                    return;
                }
                const sender = {
                    userID: username,
                };

                return fetchGuest(sender)
                    .then((response) => {
                        if (response.status === 200) {
                            return { data: response.data };
                        }
                        Swal.showValidationMessage(`รหัสประจำตัวประชาชนไม่ถูกต้องโปรดกรอกเเบบรายงานตัว`);
                    })
                    .catch(() => {
                        Swal.showValidationMessage(`รหัสประจำตัวประชาชนไม่ถูกต้องโปรดกรอกเเบบรายงานตัว`);
                    });
            },
        }).then((result) => {
            if (result.isConfirmed === true && result.value.data) {
                console.log(result.value.data);
                dispatch({
                    type: 'FETCH_GUST_SUCCESS',
                    payload: result.value.data,
                });
            }
        });
    }

    //LOOUT
    function setLogout() {
        if (checkin.profile) {
            return;
        }

        Appdb.clearToken();
        Appdb.clearState('ISCHECKIN');
        Appdb.clearState('ISADMIN');
        Appdb.clearData('CHECKIN');

        dispatch({
            type: 'FETCH_LOGOUT_SUCCESS',
        });
    }

    //ADMIN
    function setAdmin() {

        dispatch({
            type: 'FETCH_ADMIN',
            payload: true,
        });
        Appdb.setState('ISADMIN', true);
    }

    //Normal
    function setNormal() {

        dispatch({
            type: 'FETCH_ADMIN',
            payload: false,
        });
        Appdb.setState('ISADMIN', false);
    }

    //LOAD
    function onloadUser() {
        const token = Appdb.getAccessToken();
        if (token) {
            fetchUser(token).then((response) => {
                dispatch({
                    type: 'FETCH_USER_SUCCESS',
                    payload: response.data,
                });
            });
        }
    }

    if (isFetching) {
        return (
            <div className="flex h-screen">
                <div className="m-auto">
                    {isError ? (
                        <div className="error text-center">
                            <NotFoundIcon className="m-auto" />
                            <p>ไม่พบรหัสสถานที่โปรดสแกน qr code อีกครั้ง</p>
                            <small>{pId}</small>
                            <br />
                            <Link to="/passport">SNRU PASSPORT</Link>
                        </div>
                    ) : (
                        <div className="loding">
                            <LoadIcon className="m-auto" />
                            <p>กำลังโหลดข้อมูล....</p>
                        </div>
                    )}
                </div>
            </div>
        );
    }

    return (
        <div className="Main">

            <Status user={user} />

            <Place user={user} place={place} />

            <div className="container max-w-screen-lg mx-auto">
                {
                    isAdmin ? (
                        <div className="barcode">
                            <div className="send text-center px-5 py-2">
                                <h2 className="font-semibold text-xl text-gray-600">ระบบเช็คอิน</h2>
                                <p className="text-gray-500 mb-6">สำหรับเจ้าหน้าที่</p>
                                <div className="bg-white text-left rounded shadow-lg p-4 px-4 md:p-8 mb-6">
                                    <div className="grid gap-4 gap-y-2 text-sm grid-cols-1 lg:grid-cols-3">

                                        <div className={"vaccine flex flex-col h-24 h-full justify-center border-4 bg-gray-100" + (userid.status && (userid.status.vaccinestatus > 0 ? (userid.status.vaccinestatus > 1 ? ' --pass' : ' --progress') : ' --no'))}>
                                            {
                                                userid.checkin ?
                                                    (
                                                        userid.profile.agency === "นักศึกษา" ?
                                                            <img className="object-contain h-64 w-full" src={'https://aris.snru.ac.th/image_std/' + userid.profile.username + '.jpg'} alt="" /> :
                                                            <img className="object-contain h-64 w-full" src={'https://sso.snru.ac.th/picuser.aspx?id=' + userid.profile.citizen_id} alt="" />
                                                    ) : (
                                                        <img className="object-contain h-64 w-full" src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" alt="" />
                                                    )
                                            }
                                        </div>

                                        <div className="userid lg:col-span-2">
                                            <div className="grid gap-4 gap-y-2 text-sm grid-cols-1 md:grid-cols-5">
                                                <div className="md:col-span-5">
                                                    <label htmlFor="barcode">Barcode / QR</label>
                                                    <input
                                                        type="text"
                                                        name="barcode"
                                                        className="h-10 border mt-1 rounded px-4 w-full bg-gray-50"
                                                        onChange={e => setuserID(e.target.value)}
                                                        value={userID}
                                                        onKeyPress={event => {
                                                            if (event.key === 'Enter') {
                                                                var regEx = /^[0-9a-zA-Z]+$/;
                                                                if (userID !== lastID && userID.match(regEx)) {
                                                                    setlastID(userID);
                                                                    setUserCheckin();
                                                                }
                                                                setuserID('');
                                                                setTemp(35.5);
                                                            }
                                                        }}
                                                    />
                                                </div>

                                                <div className="md:col-span-5">
                                                    <h4>ช่วงอุณหภูมิ {temp}</h4>
                                                    <Select
                                                        className="temp"
                                                        options={options}
                                                        value={options.find((obj) => obj.value === temp)}
                                                        onChange={e => setTemp(e.value)}
                                                    />
                                                </div>

                                                <hr className="md:col-span-5" />

                                                <div className="md:col-span-5">
                                                    <h4 className="text-gray-600 text-sm">รหัส</h4>
                                                    <span className="mt-2 text-xl font-medium text-gray-800">{userid.profile ? (userid.profile.username.substr(0, userid.profile.username.length - 4) + 'XXXX') : '-'}</span>
                                                </div>

                                                <div className="md:col-span-3">
                                                    <h4 className="text-gray-600 text-sm">ชื่อ - นามสกุล</h4>
                                                    <span className="mt-2 text-xl font-medium text-gray-800">{userid.profile ? (userid.profile.display) : '-'}</span>
                                                </div>

                                                <div className="md:col-span-2">
                                                    {/* <h4 className="text-gray-600 text-sm">ประเภท</h4>
                                                    <span className="mt-2 text-xl font-medium text-gray-800">{userid.profile ? (userid.profile.agency) : '-'}</span> */}
                                                </div>

                                                <div className="md:col-span-3">
                                                    <h4 className="text-gray-600 text-sm">เช็คอิน</h4>
                                                    <span className="mt-2 text-xl font-medium text-gray-800">{userid.checkin ? (userid.checkin.checkin_date) : '-'}</span>
                                                </div>

                                                <div className="md:col-span-2">
                                                    <h4 className="text-gray-600 text-sm">อุณหภูมิ</h4>
                                                    <span className="mt-2 text-xl font-medium text-gray-800">{userid.checkin ? (userid.checkin.userTemp) : '-'}</span>
                                                </div>

                                                <div className="md:col-span-5">
                                                    <h4 className="text-gray-600 text-sm">สถานะวัคซีน</h4>
                                                    <span className="mt-2 text-xl font-medium text-gray-800">{userid.status ? (userid.status.vaccine) : '-'}</span>
                                                </div>

                                                <hr className="md:col-span-5" />
                                                {
                                                    userid.status && (
                                                        <div className="md:col-span-5">
                                                            <div className={"msg rounded-b text-black-900 px-4 py-3 shadow-md border-t-8" + (userid.status && (userid.status.vaccinestatus > 0 ? (userid.status.vaccinestatus > 1 ? ' --pass' : ' --progress') : ' --no'))} role="alert">
                                                                <div className="flex">
                                                                    <div className="p-4"><svg className="fill-current h-6 w-6 text-teal-500 mr-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z" /></svg></div>
                                                                    <div>
                                                                        <p className="font-bold">{userid.status.error ? 'ผิดผลาด' : 'สำเร็จ'}</p>
                                                                        <p className="text-sm">{userid.status.message}</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="checkin">
                            <div className="temp text-center px-5 py-2">
                                <h4>ช่วงอุณหภูมิ <b>{temp}</b></h4>
                                {
                                    !tId && (
                                        <Select
                                            className="temp"
                                            options={options}
                                            value={options.find((obj) => obj.value === temp)}
                                            onChange={e => setTemp(e.value)}
                                        />)
                                }
                            </div>
                            <div className="send text-center px-5 py-2">
                                <div className="action">
                                    <div className="grid grid-cols-2 gap-4">
                                        <button
                                            className={
                                                'h-full w-full p-6 dark:bg-gray-700 bg-white hover:shadow-xl rounded-xl shadow-lg text-2xl font-bold' +
                                                (checkin.profile && ' --disble')
                                            }
                                            onClick={setCheckin}
                                        >
                                            <CheckinIcon className="logo --pass" />
                                            เช็คอิน
                                        </button>
                                        <button
                                            className={
                                                'h-full w-full p-6 dark:bg-gray-700 bg-white hover:shadow-xl rounded-xl shadow-lg text-2xl font-bold' +
                                                (!checkin.profile && ' --disble')
                                            }
                                            onClick={setCheckout}
                                        >
                                            <CheckoutIcon className="logo --risk" />
                                            เช็คเอาท์
                                        </button>
                                    </div>
                                </div>

                                <div className="info p-2">
                                    <p>กรุณาเลือกเช็คอินหรือเช็คเอาท์</p>
                                </div>

                            </div>
                            {
                                checkin.profile && user.profile && !isAdmin && (
                                    <Ticket user={user} place={place} checkin={checkin} />
                                )
                            }
                        </div>
                    )
                }

                <div className="footer">
                    {
                        user.profile ? (
                            <div className="flex flex-row justify-center">
                                <div className="p-1">
                                    <button onClick={setLogout}>ออกจากระบบ</button> {
                                        user.profile.agency === 'บุคลากร' ? (
                                            isAdmin ? <button onClick={setNormal}> | ระบบเช็คอิน</button> : <button onClick={setAdmin}> | ระบบเช็คอิน</button>
                                        ) : <div />}
                                </div>
                            </div>
                        ) : (
                            <div className="flex flex-row justify-center">
                                <div className="p-1">
                                    <button onClick={setLogin}>เข้าสู่ระบบ</button> | <button onClick={setGust}>บุคคลทั่วไป</button>
                                </div>
                            </div>
                        )
                    }
                </div>

            </div>
        </div>
    );
}

export default App;
